import React from "react";
import { FormGroup, Radio } from "./index";
import {useTranslation} from "react-i18next";

export const YesNoRadioQuestion = ({ name, required, label, children }) => {
  const { t } = useTranslation();

  return (
    <FormGroup name={name} required={required} label={label}>
      <Radio
        rules={{ required }}
        name={name}
        label={t("Yes")}
        id={`${name}_yes`}
        value="Yes"
      />
      <Radio
        rules={{ required }}
        name={name}
        label={t("No")}
        id={`${name}_no`}
        value="No"
      />
      {children}
    </FormGroup>
  );
};
